module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-wrapper"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "con"
  }, [_c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": "/static/img/ic_tel.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(_vm.config_info.service_macao_number_title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.config_info.service_macao_number))])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/img/ic_zhuanyuan.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(_vm.config_info.service_qq))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.config_info.service_kefu_url_1
    }
  }, [_vm._v(_vm._s(_vm.config_info.service_kefu_info_1))])])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/img/ic_zhuanyuan.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(_vm.config_info.service_wechat))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.config_info.service_kefu_url_2
    }
  }, [_vm._v(_vm._s(_vm.config_info.service_kefu_info_2))])])])]), _vm._v(" "), _c('img', {
    staticClass: "other",
    attrs: {
      "src": "/static/img/f_logo.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v(_vm._s(_vm.config_info.site_copyright))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3f77a06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/different/taiyangcheng018/footer/footer.vue
// module id = 642
// module chunks = 27